// import Vue from 'vue';
// // import Vuex from 'vuex';
// Vue.use(Vuex)

/**
 *
 *
 * 初始化store
 *
 */


//创建store
window.store = new Vuex.Store({
  state: {
    //所有组件的状态存放在这个对象里面
    //状态更新同时更新本地localstorage
    comstatus: {},
    // 菜单数据
    menuData: [],
    //动态组件 ,默认是首页
    currentComponent: 'homepage',
    //用户app信息
    appframe:{
      
    },
    userInfo: null,
    //当前一级菜单数据,
    focusFirMD:"首页",
    //当前二级菜单数据，
    focusSecMD:'',
    currentSecMD:[],
    //当前三级菜单数据，
    focusThiMD:'',
    currentThiMD:[],
    showFiMenuPop:false,
    firMenuData:[],
    // 导航面包屑
    breadcrumbData:[{name:'首页', component:'homepage'}],
    // 非导航面包屑
    compBreadcrumbData:[],
    // compBreadcrumbData:[{name:'新增', component:'homepage'}],
    // history:[{name:'首页', component:'homepage'}],
    permission: null,
    defaultActiveId: '首页_000',
  },
  mutations: {
    //状态更新
    setcomstatus(state, newstatus) {
      if (newstatus) {
        state.comstatus = newstatus
      }
    },
    //菜单更新
    setmenu(state, newmenu) {
      if (newmenu) {
        state.menuData = newmenu
      }
    },
    //菜单动态组件显示页面
    setcomponent(state, com) {
      if (com) {
        state.currentComponent = com
      }
    },
    //设置用户信息
    setuserInfo(state, data) {
      if (data) {
        state.userInfo = data
      }
    },
    setFocusFirMD(state, str){
      state.focusFirMD = str;
    },
    setFocusSecMD(state, str){
      state.focusSecMD = str;
    },
    setCurrentSecMD(state, arr){
      state.currentSecMD = arr;
    },
    setFocusThiMD(state, str){
      state.focusThiMD = str;
    },
    setCurrentThiMD(state, arr){
      state.currentThiMD = arr;
    },
    setShowFiMenuPop(state, boolearn){
      state.showFiMenuPop = boolearn;
    },
    setFirMenuData(state, arr){
      state.firMenuData = arr;
    },
    setBreadcrumbData(state, data){
      state.breadcrumbData = data;
    },
    setComBreadcrumbData(state, data){
      state.compBreadcrumbData = data;
    },
    // setHistory(state, data){
    //   state.history = data;
    // },

    setPermission(state, obj) {
      state.permission = _.cloneDeep(obj);
    },

    setDefaultActiveId(state, str) {
      state.defaultActiveId = str;
    },
  }
})

// export default store;


// WEBPACK FOOTER //
// ./src/store.js